export default __webpack_public_path__ + "static/web-reserve-df46b6b82e7b1e8017b2e9ff177a1ec5.png";